import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import { isInternalLink } from 'helpers/ContentHelper';

export const SERIES_DETAIL_OVERLAY = 'SERIES_DETAIL_OVERLAY';
export const PLAYABLE_OVERLAY = 'PLAYABLE_OVERLAY';
export const Overlay = props => {
  const {
    children,
    isHoverStateV2,
    isUpcoming,
    isSeries,
    isSeriesDetailAvailable,
    link,
    playButtonClick,
    theme,
    type,
    onMouseDown,
  } = props;

  switch (type) {
    case SERIES_DETAIL_OVERLAY:
      return (
        <Link
          className={classNames(theme.playButtonOverlay, theme.playButtonScale)}
          onClick={playButtonClick}
          onMouseDown={onMouseDown}
          to={link}
        >
          <div className={classNames([theme.playButton])}>{children}</div>
        </Link>
      );
    case PLAYABLE_OVERLAY:
      if (isInternalLink(link)) {
        return (
          <div
            className={classNames(
              theme.playButtonOverlay,
              isHoverStateV2 && !isUpcoming && !isSeries && theme.playButtonOverlayHoverStateV2,
            )}
          >
            <Link
              aria-label="play button"
              onClick={playButtonClick}
              onMouseDown={onMouseDown}
              className={classNames([
                theme.playButton,
                isHoverStateV2 && theme.playButtonV2,
                isHoverStateV2 && (isSeries || isUpcoming) && theme.playableShowTile,
                !isSeriesDetailAvailable && isUpcoming && theme.cursorDefault,
              ])}
              to={link}
            >
              {!isUpcoming && !isSeries && children}
            </Link>
          </div>
        );
      }
      return (
        <div
          className={classNames(
            theme.playButtonOverlay,
            isHoverStateV2 && !isUpcoming && !isSeries && theme.playButtonOverlayHoverStateV2,
          )}
        >
          <a
            aria-label="play button"
            onClick={playButtonClick}
            onMouseDown={onMouseDown}
            className={classNames([
              theme.playButton,
              isHoverStateV2 && theme.playButtonV2,
              isHoverStateV2 && (isSeries || isUpcoming) && theme.playableShowTile,
              !isSeriesDetailAvailable && isUpcoming && theme.cursorDefault,
            ])}
            href={link}
          >
            {!isUpcoming && !isSeries && children}
          </a>
        </div>
      );
    default:
      return null;
  }
};

Overlay.propTypes = {
  children: PropTypes.node.isRequired,
  isHoverStateV2: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  isSeries: PropTypes.bool,
  isSeriesDetailAvailable: PropTypes.bool,
  link: PropTypes.string,
  playButtonClick: PropTypes.func,
  theme: PropTypes.shape({}),
  type: PropTypes.string,
  onMouseDown: PropTypes.func,
};
